/**
 * Single-Product Customizer (Bundy-Style Layout)
 * ================================================
 * Handles the single-product engraving flow with front/back
 * support, gallery, text, and upload options.
 * Scoped to .sc_popup to avoid conflicts.
 */

$(document).ready(function () {
  // Only run when the single customizer popup exists (and NOT on Bundy)
  if (!$(".sc_popup")[0]) return;
  if ($(".popup_bundy_customizer")[0]) return;

  var FONT_CLASSES = "font-Manderley font-Crosterian font-Whiphand font-Socialist";

  // State — text and logo are tracked independently; getSideType() computes the combined type
  var scState = {
    activeSide: "front", // 'front' or 'back'
    front: { text: "", font: "Manderley", logoUrl: "", logoName: "" },
    back: { text: "", font: "Manderley", logoUrl: "", logoName: "" },
    activeColour: "",
    variantId: ""
  };

  // Compute the effective type for a side: "", "text", "logo", or "both"
  function getSideType(side) {
    var s = scState[side];
    if (s.text && s.logoUrl) return "both";
    if (s.text) return "text";
    if (s.logoUrl) return "logo";
    return "";
  }

  var sizeTag = $(".sc_popup").attr("data-sizetag") || "";
  var disableGallery = $(".sc_popup").attr("data-disable-gallery") === "true";

  // If wine, default to back only
  if (sizeTag === "wine") {
    scState.activeSide = "back";
  }

  // ==========================================
  // OPEN CUSTOMIZER
  // ==========================================
  $(document).on("click", ".customise_button", function () {
    // Don't intercept if Bundy popup exists
    if ($(".popup_bundy_customizer")[0]) return;
    if (!$(".sc_popup")[0]) return;

    // Hide the standard customizer if it exists
    $(".popup_pd_customizer").removeClass("active");

    // Reset state
    scState.front = { text: "", font: "Manderley", logoUrl: "", logoName: "" };
    scState.back = { text: "", font: "Manderley", logoUrl: "", logoName: "" };
    if (sizeTag === "wine") {
      scState.activeSide = "back";
    } else {
      scState.activeSide = "front";
    }

    // Reset UI
    resetScUI();

    // Sync colour from the product page
    syncColourFromPage();

    // Check gallery disable for the initially active variant
    var activeColor = $(".sc_colour_swatch.active").attr("data-color");
    var activeVariant = $(".sc_variant_data[data-color='" + activeColor + "']").first();
    if (activeVariant.length && activeVariant.attr("data-gallery") === "true") {
      $(".sc_gallery_option").hide();
    } else if (disableGallery) {
      $(".sc_gallery_option").hide();
    } else {
      $(".sc_gallery_option").show();
    }

    // Show popup
    $("body").addClass("sc_customizer_active");
    $(".sc_popup").addClass("active");
  });

  // ==========================================
  // CLOSE CUSTOMIZER
  // ==========================================
  $(document).on("click", ".sc_close_btn", function () {
    $(".sc_popup").removeClass("active");
    $("body").removeClass("sc_customizer_active");
  });

  // Close on overlay click
  $(document).on("click", ".sc_popup", function (e) {
    if ($(e.target).hasClass("sc_popup")) {
      $(".sc_popup").removeClass("active");
      $("body").removeClass("sc_customizer_active");
    }
  });

  // ==========================================
  // COLOUR SWATCH SELECTION
  // ==========================================
  $(document).on("click", ".sc_colour_swatch", function () {
    $(".sc_colour_swatch").removeClass("active");
    $(this).addClass("active");

    var colorHandle = $(this).attr("data-color");
    var colorName = $(this).attr("data-name");
    scState.activeColour = colorHandle;

    // Update colour name display
    $(".sc_selected_colour_name").text(colorName.split(" - ")[0]);
    $(".sc_selected_colour_name_inline").text(colorName.split(" - ")[0]);

    // Update variant name
    $(".sc_variant_name").text(colorName);

    // Find matching variant data and update images
    var variantData = $(".sc_variant_data[data-color='" + colorHandle + "']").first();
    if (variantData.length) {
      var frontSrc = variantData.attr("data-front");
      var backSrc = variantData.attr("data-back");
      var textureUrl = variantData.attr("data-texture");
      scState.variantId = variantData.attr("data-variant-id");

      if (frontSrc) $(".sc_front_image").attr("src", frontSrc);
      if (backSrc) $(".sc_back_image").attr("src", backSrc);
      if (textureUrl) {
        $(".sc_textup").css("background-image", 'url("' + textureUrl + '")');
      }

      // Also sync the main product page colour swatch
      var mainSwatch = $(".color_items[data-color='" + colorHandle + "']");
      if (mainSwatch.length && !mainSwatch.hasClass("active")) {
        mainSwatch.trigger("click");
      }

      // Check gallery disable state for this variant
      var galleryDisabled = variantData.attr("data-gallery") === "true";
      if (galleryDisabled) {
        $(".sc_gallery_option").hide();
      } else {
        $(".sc_gallery_option").show();
      }
    }
  });

  // ==========================================
  // TAB SWITCHING (Front/Back)
  // ==========================================
  $(document).on("click", ".sc_tab_front", function () {
    saveCurrentSideState();
    scState.activeSide = "front";
    $(".sc_tab").removeClass("active");
    $(this).addClass("active");
    $(".sc_front_preview").addClass("active");
    $(".sc_back_preview").removeClass("active");
    restoreSideState("front");
    goToSelectionMenu();
  });

  $(document).on("click", ".sc_tab_back", function () {
    saveCurrentSideState();
    scState.activeSide = "back";
    $(".sc_tab").removeClass("active");
    $(this).addClass("active");
    $(".sc_back_preview").addClass("active");
    $(".sc_front_preview").removeClass("active");
    restoreSideState("back");
    goToSelectionMenu();
  });

  // ==========================================
  // GALLERY OPTION
  // ==========================================
  $(document).on("click", ".sc_gallery_option", function () {
    $(".sc_selection_menu").addClass("hide");
    $(".sc_gallery_section").removeClass("hide");
    $(".sc_text_section").addClass("hide");
    $(".sc_skip_review_btn").addClass("hide");
    $(".sc_menu_review_btn").addClass("hide");
    // Show categories, hide items
    $(".sc_gallery_categories").removeClass("hide");
    $(".sc_gallery_items").addClass("hide");
  });

  // Gallery category click
  $(document).on("click", ".sc_gallery_cat", function () {
    var cat = $(this).attr("data-cat");
    $(".sc_gallery_categories").addClass("hide");
    $(".sc_gallery_items").removeClass("hide");
    $(".sc_gallery_section > .sc_back_btn").addClass("hide");
    $(".sc_cat_content").addClass("hide");
    $(".sc_cat_" + cat).removeClass("hide");
    // Reset selection
    $(".sc_cat_content .image").removeClass("active");
    $(".sc_search_input").val("");
    $(".sc_cat_content .logo-item-detail").show();
  });

  // Gallery back to categories
  $(document).on("click", ".sc_gallery_back_btn", function () {
    $(".sc_gallery_items").addClass("hide");
    $(".sc_gallery_categories").removeClass("hide");
    $(".sc_gallery_section > .sc_back_btn").removeClass("hide");
  });

  // Gallery search
  $(document).on("keyup", ".sc_search_input", function () {
    var query = $(this).val().toLowerCase();
    $(".sc_cat_content:not(.hide) .logo-item-detail").each(function () {
      var name = $(this).find(".prepared-item-title").text().toLowerCase();
      if (name.indexOf(query) >= 0 || query === "") {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  });

  // Gallery logo selection — show logo overlay WITHOUT hiding text overlay
  $(document).on("click", ".sc_cat_content .image", function () {
    $(".sc_cat_content .image").removeClass("active");
    $(this).addClass("active");
    $(".sc_preview_gallery").removeAttr("disabled");
    $(".sc_preview_gallery_top").removeAttr("disabled");
    $(".sc_gallery_nav_top").addClass("active").removeClass("hide");
    $(".sc_clear_gallery").removeAttr("disabled");

    var logoSrc = $(this).attr("data-texture") || $(this).find("img").attr("src");
    var logoName = $(this).closest(".logo-item-detail").find(".prepared-item-title").text().trim();

    // Update preview — show logo but leave text overlay as-is
    var activePreview = scState.activeSide === "front" ? ".sc_front_preview" : ".sc_back_preview";
    $(activePreview + " .sc_logo_overlay").removeClass("hide");
    $(activePreview + " .sc_logo_img").attr("src", logoSrc);
    $(activePreview + " .sc_uploadingimg").hide();
  });

  // Gallery preview/review — save logo without clearing text
  $(document).on("click", ".sc_preview_gallery, .sc_preview_gallery_top", function () {
    var activeLogo = $(".sc_cat_content .image.active");
    if (!activeLogo.length) return;

    var logoSrc = activeLogo.attr("data-texture") || activeLogo.find("img").attr("src");
    var logoName = activeLogo.closest(".logo-item-detail").find(".prepared-item-title").text().trim();

    scState[scState.activeSide].logoUrl = logoSrc;
    scState[scState.activeSide].logoName = logoName;
    // text and font are left untouched

    checkAndShowReview();
  });

  // Clear gallery — only clears logo state, leaves text intact
  $(document).on("click", ".sc_clear_gallery, .sc_clear_gallery_top", function () {
    $(".sc_cat_content .image").removeClass("active");
    $(".sc_preview_gallery").attr("disabled", "disabled");
    $(".sc_preview_gallery_top").attr("disabled", "disabled");
    $(".sc_gallery_nav_top").removeClass("active").addClass("hide");
    $(".sc_clear_gallery").attr("disabled", "disabled");
    scState[scState.activeSide].logoUrl = "";
    scState[scState.activeSide].logoName = "";
    // text state is left untouched

    var activePreview = scState.activeSide === "front" ? ".sc_front_preview" : ".sc_back_preview";
    $(activePreview + " .sc_logo_overlay").addClass("hide");
    $(activePreview + " .sc_logo_img").attr("src", "");
  });

  // ==========================================
  // TEXT OPTION
  // ==========================================
  $(document).on("click", ".sc_text_option", function () {
    $(".sc_selection_menu").addClass("hide");
    $(".sc_text_section").removeClass("hide");
    $(".sc_gallery_section").addClass("hide");
    $(".sc_skip_review_btn").addClass("hide");
    $(".sc_menu_review_btn").addClass("hide");

    // Restore existing text for this side (regardless of whether logo is also set)
    var state = scState[scState.activeSide];
    if (state.text) {
      $(".sc_text_input").val(state.text);
      $(".sc_text_input").removeClass(FONT_CLASSES).addClass("font-" + state.font);
      $(".sc_font_item").removeClass("active");
      $(".sc_font_item[data-font='" + state.font + "']").addClass("active");
      $(".sc_preview_text").removeAttr("disabled");
    } else {
      $(".sc_text_input").val("");
      $(".sc_text_input").removeClass(FONT_CLASSES).addClass("font-Manderley");
      $(".sc_font_item").removeClass("active");
      $(".sc_font_item[data-font='Manderley']").addClass("active");
      $(".sc_preview_text").attr("disabled", "disabled");
    }
  });

  // Text input handling
  var RE_EMOJI = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g;
  var RE_SPECIAL = /[^a-zA-Z0-9\s]/g;

  // Fix iOS Safari zoom: reset viewport after keyboard dismissal
  $(document).on("blur", ".sc_text_input", function () {
    if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
      console.log("[ATC] items:", JSON.stringify(items, null, 2));
    setTimeout(function () {
        window.scrollTo(0, 0);
        document.body.style.zoom = 1;
      }, 100);
    }
  });

  $(document).on("keyup keydown change paste input", ".sc_text_input", function (event) {
    if (event.key === "Enter") {
      event.preventDefault();
      return false;
    }

    var $elem = $(this);
    var content = $elem.val();

    // Remove emojis and special characters
    if (RE_EMOJI.test(content) || RE_SPECIAL.test(content)) {
      content = content.replace(RE_EMOJI, "").replace(RE_SPECIAL, "");
      $elem.val(content);
    }

    var valLength = content.length;
    var maxSize = parseInt($elem.attr("data-size")) || 10;

    if (valLength > maxSize) {
      $(".sc_char_warning").removeClass("hide");
      $(".sc_preview_text").attr("disabled", "disabled");
    } else {
      $(".sc_char_warning").addClass("hide");
      if (valLength > 0) {
        $(".sc_preview_text").removeAttr("disabled");
      } else {
        $(".sc_preview_text").attr("disabled", "disabled");
      }
    }

    // Update preview
    updateActivePreviewText(content);
  });

  // Font selection
  $(document).on("click", ".sc_font_item", function () {
    $(".sc_font_item").removeClass("active");
    $(this).addClass("active");
    var font = $(this).attr("data-font");
    $(".sc_text_input").removeClass(FONT_CLASSES).addClass("font-" + font);

    // Update preview font
    var activePreview = scState.activeSide === "front" ? ".sc_front_preview" : ".sc_back_preview";
    $(activePreview + " .sc_textup").removeClass(FONT_CLASSES).addClass("font-" + font);
  });

  // Text preview/review button — saves text without clearing logo
  $(document).on("click", ".sc_preview_text", function () {
    var text = $(".sc_text_input").val().trim();
    var font = $(".sc_font_item.active").attr("data-font");

    scState[scState.activeSide].text = text;
    scState[scState.activeSide].font = font;
    // logoUrl and logoName are left untouched

    updateActivePreviewText(text);
    var activePreview = scState.activeSide === "front" ? ".sc_front_preview" : ".sc_back_preview";
    $(activePreview + " .sc_textup").removeClass(FONT_CLASSES).addClass("font-" + font);

    checkAndShowReview();
  });

  // Clear text — only clears text state, leaves logo intact
  $(document).on("click", ".sc_clear_text", function () {
    $(".sc_text_input").val("");
    $(".sc_preview_text").attr("disabled", "disabled");
    scState[scState.activeSide].text = "";
    // logoUrl/logoName are left untouched

    var activePreview = scState.activeSide === "front" ? ".sc_front_preview" : ".sc_back_preview";
    $(activePreview + " .sc_text_overlay").addClass("hide");
    $(activePreview + " .sc_textup").html("");
    // logo overlay is left untouched
  });

  // Back buttons — save current state before navigating away
  $(document).on("click", ".sc_back_btn", function () {
    saveCurrentSideState();
    goToSelectionMenu();
  });

  // Go Back from review/add-to-cart screen
  $(document).on("click", ".sc_review_back_nav", function () {
    // Hide the review section, show the customizer again
    $(".sc_addtocart_section").addClass("hide");
    $(".sc_customize_section").removeClass("hide");
    $(".sc_tabs").removeClass("hide");
    $(".sc_outer_box").removeClass("sc_review_mode");

    // Restore the active side tab and preview
    if (scState.activeSide === "back") {
      $(".sc_tab").removeClass("active");
      $(".sc_tab_back").addClass("active");
      $(".sc_back_preview").addClass("active");
      $(".sc_front_preview").removeClass("active");
    } else {
      $(".sc_tab").removeClass("active");
      $(".sc_tab_front").addClass("active");
      $(".sc_front_preview").addClass("active");
      $(".sc_back_preview").removeClass("active");
    }

    // Go to the selection menu
    goToSelectionMenu();
  });

  // ==========================================
  // REVIEW & ADD TO CART
  // ==========================================

  // Inject the "Skip — Review My Design" button once into the tabs bar
  if (!$(".sc_skip_review_btn")[0]) {
    $(".sc_tabs").append(
      '<button class="sc_skip_review_btn btn btn--primary btn--small hide" type="button" '
      + 'style="background:#6c2bd9;color:#fff;margin-top:8px;width:100%;padding:12px;border-radius:6px;font-size:14px;cursor:pointer;border:none;">'
      + 'Review My Design</button>'
    );
  }

  // Handle click on the Skip button
  $(document).on("click", ".sc_skip_review_btn", function () {
    saveCurrentSideState();
    $(".sc_skip_review_btn").addClass("hide");
    updateReviewSummary();
    showAddToCart();
  });

  // Handle click on the selection menu Review button
  $(document).on("click", ".sc_menu_review_btn", function () {
    saveCurrentSideState();
    updateReviewSummary();
    showAddToCart();
  });

  function checkAndShowReview() {
    var frontHas = getSideType("front") !== "";
    var backHas = getSideType("back") !== "";
    var isWine = sizeTag === "wine";

    updateReviewSummary();

    if (isWine && backHas) {
      // Wine only has back - go straight to review
      $(".sc_skip_review_btn").addClass("hide");
      showAddToCart();
    } else if (frontHas && backHas) {
      // Both sides done - go straight to review
      $(".sc_skip_review_btn").addClass("hide");
      showAddToCart();
    } else if (frontHas || backHas) {
      // Only one side done — stay on current side, show Review button
      // Let the customer choose to add the other side or skip to review
      goToSelectionMenu();
      $(".sc_skip_review_btn").removeClass("hide");
    }
  }

  function showAddToCart() {
    $(".sc_addtocart_section").removeClass("hide");
    $(".sc_customize_section").addClass("hide");
    $(".sc_tabs").addClass("hide");
    $(".sc_skip_review_btn").addClass("hide");

    var frontHas = getSideType("front") !== "";
    var backHas = getSideType("back") !== "";
    var isWine = sizeTag === "wine";

    // Only show the sides that have content
    if (isWine) {
      $(".sc_outer_box").removeClass("sc_review_mode");
      $(".sc_front_preview").removeClass("active");
      $(".sc_back_preview").addClass("active");
    } else if (frontHas && backHas) {
      // Both sides customized — expand layout, show both full size
      $(".sc_outer_box").addClass("sc_review_mode");
      $(".sc_front_preview").addClass("active");
      $(".sc_back_preview").addClass("active");
    } else if (frontHas) {
      $(".sc_outer_box").removeClass("sc_review_mode");
      $(".sc_front_preview").addClass("active");
      $(".sc_back_preview").removeClass("active");
    } else if (backHas) {
      $(".sc_outer_box").removeClass("sc_review_mode");
      $(".sc_front_preview").removeClass("active");
      $(".sc_back_preview").addClass("active");
    }
  }

  function updateReviewSummary() {
    // Front summary
    var frontType = getSideType("front");
    if (frontType === "both") {
      $(".sc_review_front_text").text('"' + scState.front.text + '" (' + scState.front.font + ') + Design: ' + scState.front.logoName);
    } else if (frontType === "text") {
      $(".sc_review_front_text").text('"' + scState.front.text + '" (' + scState.front.font + ')');
    } else if (frontType === "logo") {
      $(".sc_review_front_text").text("Design: " + scState.front.logoName);
    } else {
      $(".sc_review_front_text").text("None");
    }

    // Back summary
    var backType = getSideType("back");
    if (backType === "both") {
      $(".sc_review_back_text").text('"' + scState.back.text + '" (' + scState.back.font + ') + Design: ' + scState.back.logoName);
    } else if (backType === "text") {
      $(".sc_review_back_text").text('"' + scState.back.text + '" (' + scState.back.font + ')');
    } else if (backType === "logo") {
      $(".sc_review_back_text").text("Design: " + scState.back.logoName);
    } else {
      $(".sc_review_back_text").text("None");
    }
  }

  // Quantity controls
  $(document).on("click", ".sc_qty_add", function () {
    var input = $(".sc_qty_input");
    input.val(parseInt(input.val()) + 1);
  });

  $(document).on("click", ".sc_qty_sub", function () {
    var input = $(".sc_qty_input");
    if (parseInt(input.val()) > 1) {
      input.val(parseInt(input.val()) - 1);
    }
  });

  // Add to Cart — confirm details popup
  $(document).on("click", ".sc_add_to_cart", function () {
    // Ensure latest state is captured before building confirmation
    saveCurrentSideState();
    var details = "";
    if (sizeTag !== "wine") {
      details += "<p><strong>Front:</strong> ";
      var frontType = getSideType("front");
      if (frontType === "text") {
        details += 'Text: "' + scState.front.text + '" (Font: ' + scState.front.font + ")";
      } else if (frontType === "logo") {
        details += "Design: " + scState.front.logoName;
      } else if (frontType === "both") {
        details += 'Text: "' + scState.front.text + '" (Font: ' + scState.front.font + ') + Design: ' + scState.front.logoName;
      } else {
        details += "None";
      }
      details += "</p>";
    }

    details += "<p><strong>Back:</strong> ";
    var backType = getSideType("back");
    if (backType === "text") {
      details += 'Text: "' + scState.back.text + '" (Font: ' + scState.back.font + ")";
    } else if (backType === "logo") {
      details += "Design: " + scState.back.logoName;
    } else if (backType === "both") {
      details += 'Text: "' + scState.back.text + '" (Font: ' + scState.back.font + ') + Design: ' + scState.back.logoName;
    } else {
      details += "None";
    }
    details += "</p>";

    $(".sc_confirm_details").html(details);
    $(".sc_confirm_popup").removeClass("hide");
    $(".sc_addtocart_section").addClass("hide");
  });

  // Confirmation checkbox
  $(document).on("click", ".sc_chkbox.none", function () {
    $(this).addClass("active").removeClass("none");
    $(".sc_accept_btn").removeAttr("disabled").addClass("active");
  });

  $(document).on("click", ".sc_chkbox.active", function () {
    $(this).addClass("none").removeClass("active");
    $(".sc_accept_btn").attr("disabled", "disabled").removeClass("active");
  });

  // Cancel confirmation
  $(document).on("click", ".sc_cancel_btn", function () {
    $(".sc_confirm_popup").addClass("hide");
    $(".sc_addtocart_section").removeClass("hide");
  });

  // ACCEPT - Submit to cart
  $(document).on("click", ".sc_accept_btn.active", function (e) {
    e.preventDefault();
    // Final state capture before submission
    saveCurrentSideState();

    var $btn = $(this);
    $btn.html("Loading....");

    var leftPreview = $(".sc_left_preview");
    var pricewithoutcurrency = leftPreview.attr("data-price");
    var product_title = leftPreview.attr("data-title");
    var qty = parseInt($(".sc_qty_input").val()) || 1;

    // Append active colour name to product title for engraving identification
    var activeColourName = $(".sc_colour_swatch.active").attr("data-name") || "";
    if (activeColourName) {
      var colourShort = activeColourName.split(" - ")[0];
      product_title = product_title + "- " + colourShort;
    }

    // Get variant ID - use the one from colour selection or fallback
    var var_id = scState.variantId || $(".sc_variant_data").first().attr("data-variant-id");
    var_id = parseInt(var_id);
    var customized_pd = parseInt($(".sc_data").attr("data-customized-product-id"));

    // Count customizations — text and logo are independent (max 4)
    var customQty = 0;
    if (scState.front.text)    customQty++;
    if (scState.front.logoUrl) customQty++;
    if (scState.back.text)     customQty++;
    if (scState.back.logoUrl)  customQty++;

    // Shared ID linking the main product to its engraving SKU
    var custId = Date.now().toString(36);

    // Build customization properties for the main product
    var properties = {
      _customised_product: "yes",
      "_cust_id": custId
    };

    // Front — text and logo are sent independently
    if (scState.front.text) {
      properties["FRONT ENGRAVING"] = product_title;
      properties["FRONT NAME"] = scState.front.text;
      properties["FRONT FONT"] = scState.front.font;
    }
    if (scState.front.logoUrl) {
      properties["FRONT ENGRAVING"] = product_title;
      properties["FRONT IMAGE"] = scState.front.logoUrl;
      properties["FRONT GALLERY IMAGE NAME"] = scState.front.logoName;
    }

    // Back — text and logo are sent independently
    if (scState.back.text) {
      properties["BACK ENGRAVING"] = product_title;
      properties["BACK NAME"] = scState.back.text;
      properties["BACK FONT"] = scState.back.font;
    }
    if (scState.back.logoUrl) {
      properties["BACK ENGRAVING"] = product_title;
      properties["BACK IMAGE"] = scState.back.logoUrl;
      properties["BACK GALLERY IMAGE NAME"] = scState.back.logoName;
    }

    var items = [];

    // Main product — carries all customization properties
    items.push({
      id: var_id,
      quantity: qty,
      properties: properties
    });

    // Engraving surcharge SKU — price carrier only
    if (customized_pd && !isNaN(customized_pd) && customQty > 0) {
      items.push({
        id: customized_pd,
        quantity: customQty,
        properties: {
          "_Customised Product": "yes",
          "_cust_id": custId
        }
      });
    }

    console.log("[ATC] items:", JSON.stringify(items, null, 2));
    setTimeout(function () {
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: { items: items },
        dataType: "json",
        success: function () {
          $(".js-drawer-open-button-right .material-icons-outlined").trigger("click");
          $(".sc_popup").removeClass("active");
          $("body").removeClass("sc_customizer_active");
          $btn.html("ACCEPT");
          resetScUI();
        },
        error: function () {
          console.error("Error adding to cart");
          $btn.html("ACCEPT");
          alert("There was an error adding to cart. Please try again.");
        }
      });
    }, 1000);
  });

  // ==========================================
  // HELPER FUNCTIONS
  // ==========================================
  function syncColourFromPage() {
    // Sync from the main product page's active colour swatch
    var activeMainSwatch = $(".color_items.active");
    if (activeMainSwatch.length) {
      var colorHandle = activeMainSwatch.attr("data-color");
      var matchingSwatch = $(".sc_colour_swatch[data-color='" + colorHandle + "']");
      if (matchingSwatch.length) {
        matchingSwatch.trigger("click");
      }
    } else {
      // Default to first swatch
      $(".sc_colour_swatch").first().trigger("click");
    }
  }

  function resetScUI() {
    // Reset tabs
    $(".sc_tab").removeClass("active");
    if (sizeTag === "wine") {
      $(".sc_tab_back").addClass("active");
      $(".sc_back_preview").addClass("active");
      $(".sc_front_preview").removeClass("active");
    } else {
      $(".sc_tab_front").addClass("active");
      $(".sc_front_preview").addClass("active");
      $(".sc_back_preview").removeClass("active");
    }

    // Reset sections
    $(".sc_selection_menu").removeClass("hide");
    $(".sc_text_section").addClass("hide");
    $(".sc_gallery_section").addClass("hide");
    $(".sc_addtocart_section").addClass("hide");
    $(".sc_confirm_popup").addClass("hide");
    $(".sc_customize_section").removeClass("hide");
    $(".sc_tabs").removeClass("hide");
    $(".sc_skip_review_btn").addClass("hide");
    $(".sc_menu_review_btn").addClass("hide");
    $(".sc_outer_box").removeClass("sc_review_mode");
    if (sizeTag === "wine") {
      $(".sc_tabs").addClass("sc_tabs_single");
    }

    // Reset gallery
    $(".sc_gallery_categories").removeClass("hide");
    $(".sc_gallery_items").addClass("hide");
    $(".sc_cat_content .image").removeClass("active");

    // Reset previews
    $(".sc_text_overlay").addClass("hide");
    $(".sc_textup").html("");
    $(".sc_logo_overlay").addClass("hide");
    $(".sc_logo_img").attr("src", "");
    $(".sc_uploadingimg").hide();

    // Reset inputs
    $(".sc_text_input").val("");
    $(".sc_font_item").removeClass("active");
    $(".sc_font_item[data-font='Manderley']").addClass("active");
    $(".sc_search_input").val("");

    // Reset confirmation
    $(".sc_chkbox").addClass("none").removeClass("active");
    $(".sc_accept_btn").attr("disabled", "disabled").removeClass("active");
    $(".sc_accept_btn").html("ACCEPT");

    // Reset qty
    $(".sc_qty_input").val(1);
  }

  function goToSelectionMenu() {
    $(".sc_selection_menu").removeClass("hide");
    $(".sc_text_section").addClass("hide");
    $(".sc_gallery_section").addClass("hide");
    $(".sc_gallery_categories").removeClass("hide");
    $(".sc_gallery_items").addClass("hide");
    // Don't clear gallery active state here — it's needed by saveCurrentSideState
    // Gallery active state is cleared in resetScUI instead
    $(".sc_search_input").val("");

    // Show the Review button on the selection menu if any side has content
    var anyContent = getSideType("front") !== "" || getSideType("back") !== "";
    if (anyContent) {
      $(".sc_menu_review_btn").removeClass("hide");
    } else {
      $(".sc_menu_review_btn").addClass("hide");
    }
  }

  function saveCurrentSideState() {
    if (!$(".sc_text_section").hasClass("hide")) {
      var text = $(".sc_text_input").val().trim();
      var font = $(".sc_font_item.active").attr("data-font");
      if (text) {
        // Only update text/font — leave logoUrl/logoName intact
        scState[scState.activeSide].text = text;
        scState[scState.activeSide].font = font;
      }
    }
    if (!$(".sc_gallery_section").hasClass("hide")) {
      var activeLogo = $(".sc_cat_content .image.active");
      if (activeLogo.length) {
        // Only update logo — leave text/font intact
        scState[scState.activeSide].logoUrl = activeLogo.attr("data-texture") || activeLogo.find("img").attr("src");
        scState[scState.activeSide].logoName = activeLogo.closest(".logo-item-detail").find(".prepared-item-title").text().trim();
      }
    }
  }

  function restoreSideState(side) {
    var state = scState[side];
    var preview = side === "front" ? ".sc_front_preview" : ".sc_back_preview";

    // Text and logo overlays are shown independently — both can be visible simultaneously
    if (state.text) {
      $(preview + " .sc_text_overlay").removeClass("hide");
      $(preview + " .sc_textup").html(state.text);
      $(preview + " .sc_textup").removeClass(FONT_CLASSES).addClass("font-" + state.font);
    } else {
      $(preview + " .sc_text_overlay").addClass("hide");
    }

    if (state.logoUrl) {
      $(preview + " .sc_logo_overlay").removeClass("hide");
      $(preview + " .sc_logo_img").attr("src", state.logoUrl);
    } else {
      $(preview + " .sc_logo_overlay").addClass("hide");
    }
  }

  function updateActivePreviewText(text) {
    var activePreview = scState.activeSide === "front" ? ".sc_front_preview" : ".sc_back_preview";
    if (text) {
      $(activePreview + " .sc_text_overlay").removeClass("hide");
      $(activePreview + " .sc_textup").html(text);
      // Logo overlay is left untouched — both can show simultaneously
    } else {
      $(activePreview + " .sc_text_overlay").addClass("hide");
      $(activePreview + " .sc_textup").html("");
    }
  }
});
